export enum ConditionsCheckEnum {
    true = 'TRUE',
    false = 'FALSE',
}
